export default ({ request }) => ({
  ecomEvgBulkOrderListApi(data = {}) {
    return request({
      url: '/ecom/evg/bulk/order/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgBulkOrderPurchaseListApi(data = {}) {
    return request({
      url: '/ecom/evg/bulk/order/purchaseList',
      method: 'POST',
      data,
    })
  },
  ecomEvgBulkOrderPurchaseGenerateApi(data = {}) {
    return request({
      url: '/ecom/evg/bulk/order/purchaseGenerate',
      method: 'POST',
      data,
    })
  },
  ecomEvgBulkOrderSkuPurchaseDetailsApi(data = {}) {
    return request({
      url: '/ecom/evg/bulk/order/sku/purchaseDetails',
      method: 'POST',
      data,
    })
  },
  ecomEvgBulkOrderDetailApi(data = {}) {
    return request({
      url: '/ecom/evg/bulk/order/detail',
      method: 'POST',
      data,
    })
  },
  ecomEvgBulkOrderSaveApi(data = {}) {
    return request({
      url: '/ecom/evg/bulk/order/save',
      method: 'POST',
      data,
    })
  },
  ecomEvgBulkOrderDelApi(data = {}) {
    return request({
      url: '/ecom/evg/bulk/order/del',
      method: 'POST',
      data,
    })
  },
  ecomEvgBulkOrderAuditApi(data = {}) {
    return request({
      url: '/ecom/evg/bulk/order/audit',
      method: 'POST',
      data,
    })
  },
  ecomEvgBulkOrderCopyApi(data = {}) {
    return request({
      url: '/ecom/evg/bulk/order/copy',
      method: 'POST',
      data,
    })
  },
  ecomEvgBulkOrderRollbackRequestApi(data = {}) {
    return request({
      url: '/ecom/evg/bulk/order/rollback/request',
      method: 'POST',
      data,
    })
  },
  ecomEvgBulkOrderPackingListApi(data = {}) {
    return request({
      url: '/ecom/evg/bulk/order/packing/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgBulkOrderSkuListApi(data = {}) {
    return request({
      url: '/ecom/evg/bulk/order/sku/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgBulkOrderSkuSchemeListApi(data = {}) {
    return request({
      url: '/ecom/evg/bulk/order/sku/scheme/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgBulkOrderDocListApi(data = {}) {
    return request({
      url: '/ecom/evg/bulk/order/doc/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgBulkOrderDocUploadApi(data = {}) {
    return request({
      url: '/ecom/evg/bulk/order/doc/upload',
      method: 'POST',
      data,
    })
  },
  ecomEvgBulkOrderDocDelApi(data = {}) {
    return request({
      url: '/ecom/evg/bulk/order/doc/del',
      method: 'POST',
      data,
    })
  },
})
